import React, {useState} from "react";
import AttachmentFileList, {getAttachmentFileName} from "./AttachmentFileList";

function AttachPaperclipIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="work-attach-collapsible__icon"
            aria-hidden="true"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
            />
        </svg>
    );
}

function normalizeAttachmentItems(items) {
    return (Array.isArray(items) ? items : [])
        .filter(Boolean)
        .map((item) => ({
            ...item,
            originalName: getAttachmentFileName(item),
        }));
}

export default function AttachmentCollapsibleList({items, onOpen, hoverPreview = true}) {
    const [expanded, setExpanded] = useState(false);
    const listItems = normalizeAttachmentItems(items);

    if (!listItems.length) return null;

    return (
        <div className={`work-attach-collapsible${expanded ? " is-expanded" : ""}`}>
            <button
                type="button"
                className="work-attach-collapsible__toggle"
                aria-expanded={expanded}
                onClick={() => setExpanded((prev) => !prev)}
            >
                <AttachPaperclipIcon />
                <span className="work-attach-collapsible__label">첨부파일</span>
            </button>
            {expanded && (
                <div className="work-attach-collapsible__list">
                    <AttachmentFileList
                        items={listItems}
                        readOnly
                        hoverPreview={hoverPreview}
                        onOpen={onOpen}
                    />
                </div>
            )}
        </div>
    );
}
